import React from 'react';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

import ApplicationBar from 'components/ApplicationBar';
import Paper from 'components/Paper';
import Progress from 'components/Progress';
import { newTemplatePath } from 'routes';
import Collection from 'types/Collection';
import { SortingPreferences } from 'types/Sorting';
import Template from 'types/Template';
import TemplatesTable from './TemplatesTable';

const StyledTemplates = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  margin: 1rem;

  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

interface TemplatesProps {
  collection: Collection;
  loadingTemplates: boolean;
  sortingPreferences: SortingPreferences;
  templates: Template[];
  onChangeSorting: (sortingPreferences: SortingPreferences) => void;
  onDelete: (template: Template) => void;
}

const Templates: React.FC<TemplatesProps> = ({
  collection,
  loadingTemplates,
  sortingPreferences,
  templates,
  onChangeSorting,
  onDelete,
}) => {
  return (
    <StyledTemplates>
      <ApplicationBar />

      {!collection && (
        <div
          style={{
            padding: '1rem',
            width: '100%',
            border: 'solid 1px lightgrey',
            backgroundColor: 'white',
            boxShadow: '2px 2px 5px 0px rgba(0, 0, 0, 0.5)',
          }}
        >
          <span>Select a collection</span>
        </div>
      )}

      {collection && (
        <Button variant="contained" color="primary" component={RouterLink} to={newTemplatePath(collection.id)}>
          New Template
        </Button>
      )}

      {collection && (
        <div
          style={{
            width: '100%',
            padding: '1rem',
            border: 'solid 1px lightgrey',
            backgroundColor: 'white',
            boxShadow: '2px 2px 5px 0px rgba(0, 0, 0, 0.5)',
          }}
        >
          {templates.length === 0 && !loadingTemplates && <Typography>There are no templates yet</Typography>}

          {templates.length !== 0 && !loadingTemplates && (
            <TemplatesTable
              templates={templates}
              loadingTemplates={loadingTemplates}
              sortingPreferences={sortingPreferences}
              onChangeSorting={onChangeSorting}
              onDelete={onDelete}
            />
          )}

          {loadingTemplates && <Progress />}
        </div>
      )}
    </StyledTemplates>
  );
};

export default Templates;
